var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st112{fill:none;stroke:#010101;stroke-width:2;stroke-miterlimit:10;}\n\t.st111{fill:#FFFFFF;stroke:#010101;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:3;}\n\t.st110{fill:#FFFFFF;stroke:#010101;stroke-width:2;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M346,165v198.28c0,24.14-19.58,43.72-43.72,43.72H120.72C96.58,407,77,387.42,77,363.28V165H346z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M120.72,404C98.27,404,80,385.73,80,363.28V168h263v195.28c0,22.45-18.27,40.72-40.72,40.72H120.72z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 113,
    className: "st110",
    width: 269,
    height: 52
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 116,
    className: "st111",
    width: 263,
    height: 46
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPocket);
export default __webpack_public_path__ + "static/media/POCKET.dd52763963f0448d5f788e1da4027e37.svg";
export { ForwardRef as ReactComponent };